import React from 'react';
import { Container, Grid } from '@mui/material';
import CustomTextField from '../formFields/textField';
import { ICONS } from 'src/assets/library';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { joinFormSchema } from 'src/config/yup';
import { useNavigate, useParams } from 'react-router-dom';
import CustomSelectField from '../formFields/selectField';
import LoaderButton from '../loaderButton/loaderButton';
import { OTP_VERIFICATION_MODE, genderArray, showErrorTost, showSuccessTost } from 'src/constants';
import { JOIN_USER } from 'src/apiService/apiDeclaration';
import { t } from 'i18next';

const JoinForm = () => {
  const { email } = useParams();
  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors, isValid },
    control,
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(joinFormSchema),
    defaultValues: {
      email,
      gender: 'default',
    },
  });

  const joinUser = async (data) => {
    const formData = {
      ...data,
      identificationNumber: `${data.firstName} ${data.lastName}`,
    };
    try {
      const join = await JOIN_USER(formData);
      showSuccessTost(join.message);

      navigate('/otp', { state: { email: data.email, verifcationMode: OTP_VERIFICATION_MODE.JOIN_USER } });
    } catch (error) {
      showErrorTost(error.message);
      console.error('Error during joining:', error);
    }
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(joinUser)}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              label={'Email'}
              type="email"
              icon={ICONS.email}
              controller={{
                name: 'email',
                control: control,
                errors: errors.email,
              }}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              label={t('common.fName')}
              icon={ICONS.user}
              placeholder={t('common.placeholderFirstName')}
              type="name"
              controller={{
                name: 'firstName',
                control: control,
                errors: errors.firstName,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              label={t('common.lName')}
              icon={ICONS.user}
              placeholder={t('common.placeholderLastName')}
              type="name"
              controller={{
                name: 'lastName',
                control: control,
                errors: errors.lastName,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              label={t('common.phone')}
              icon={ICONS.phone}
              type="text"
              placeholder={'+243811234567'}
              controller={{
                name: 'phoneNumber',
                control: control,
                errors: errors.phoneNumber,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomSelectField
              label={t('joinPage.gender')}
              optionsArray={genderArray}
              controller={{
                name: 'gender',
                control: control,
                errors: errors.gender,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              label={t('joinPage.dob')}
              type="date"
              pastDatesOnly={true}
              controller={{
                name: 'dob',
                control: control,
                errors: errors.dob,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              label={t('common.password')}
              icon={ICONS.lock}
              type="password"
              isPassword
              controller={{
                name: 'password',
                control: control,
                errors: errors.password,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              icon={ICONS.lock}
              label={t('common.confirmPassword')}
              type="password"
              isPassword
              controller={{
                name: 'confirmPassword',
                control: control,
                errors: errors.confirmPassword,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <LoaderButton disabled={!isValid} buttonText={t('joinPage.join')} type="submit" />
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};

export default JoinForm;
